"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeSortTeamMembers = void 0;

var makeSortTeamMembers = function makeSortTeamMembers(currentUserId) {
  return function (memberA, memberB) {
    return memberA.id === currentUserId ? -1 : "".concat(memberA.firstName, " ").concat(memberA.lastName).toLowerCase().localeCompare("".concat(memberB.firstName, " ").concat(memberB.lastName).toLowerCase());
  };
};

exports.makeSortTeamMembers = makeSortTeamMembers;